import React from 'react'
import ReactDOM from 'react-dom'
import {
  Router,
  browserHistory,
} from 'react-router'
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux'
import injectTapEventPlugin from 'react-tap-event-plugin'
import registerServiceWorker from './registerServiceWorker'

import routes from './routes'

import configureStore from './store'

const store = configureStore()

injectTapEventPlugin()

const history = syncHistoryWithStore(browserHistory, store)
const rootEl = document.getElementById('root')

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>,
  rootEl,
)

if (module.hot) {
  module.hot.accept('./routes', () => {
    const nextRoutes = require('./routes').default
    ReactDOM.render(
      <Provider store={store}>
        <Router key={Math.random()} history={history} routes={nextRoutes} />
      </Provider>,
      rootEl,
    )
  })
}

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js